import { ApiError } from './api.error';

export class MalformedServerResponseError extends ApiError {
  constructor() {
    super('APP.ERRORS.MALFORMED_SERVER_RESPONSE.TITLE', 'APP.ERRORS.MALFORMED_SERVER_RESPONSE.MESSAGE');
  }
}
